<template>
    <ul v-if="!loading">
        <CategoryFilter v-for="filter in categories" :key="filter.id" :filter="filter"></CategoryFilter>
    </ul>
</template>

<script>
import httpService from "@/components/service";
import CategoryFilter from "./CategoryFilter";

async function fetchFilters() {
    const response = await httpService.get("/components/filters");
    return response.data.filters;
}

export default {
    components: {
        CategoryFilter
    },
    data: () => ({
        categories: {},
        sections: {},
        types: {},
        loading: true
    }),
    // It fetches gain the filters everytimes we open the menu
    created() {
        fetchFilters().then(filters => {
            this.loading = false;
            Object.assign(this, filters);
        });
    }
};
</script>

<style scoped lang="scss">
ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// CategoryFilters.vue?5e2691b7